// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* screen */
@media only screen and (min-width: 1024px) {
  .homePageText {
    padding: 0.5em;
    text-align: left;
    padding-left: 13%;
    font-size: 1.1em;
    line-height: 1.6;
    color: #333;
  }
}

/* phone */
@media screen and (max-width: 632px) {
  .homePageText {
    padding: 0.5em;
    text-align: left;
    padding-left: 5%;
    font-size: 1.0em;
    line-height: 1.5;
    color: #444;
  }

  .video-responsive iframe {
    width: 100%;
    height: auto;
    position: relative;
  }
}

.video-responsive iframe {
  padding-bottom: 3em;
  border: none;
  border-radius: 8px;
}

.title {
  text-align: center;
  font-size: 1.5em;
  font-weight: 600;
  color: #444;
  margin: 1em 0;
}

body {
  margin: 0;
  font-family: 'Roboto', 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f8f9;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10vh;
}

* {
  color: #222;
  box-sizing: border-box;
}

.app {
  height: 100%;
  align-items: center;
  text-align: center;
  box-shadow: 0px 10px 10px 15px rgba(0, 0, 0, 0.05);
  padding-top: 4px;
  padding-bottom: 40px;
  display: block;
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 1200px;
}

/* ANSWERS/RIGHT SECTION */
.answer-section {
  width: 100%;
  flex-direction: column;
  padding: 1em;
  display: flex;
  justify-content: center;
}

.correct {
  background-color: #2f922f;
  color: white;
  font-weight: bold;
  padding: 0.5em;
  border-radius: 5px;
}

.incorrect {
  background-color: #ff3333;
  color: white;
  font-weight: bold;
  padding: 0.5em;
  border-radius: 5px;
}

button {
  background-color: #f3f3f3;
  border: 0;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 3px;
  margin: 10px 0;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #55555e;
  color: white;
}

button svg {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,UAAU;AACV;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;EACT,2HAA2H;EAC3H,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* screen */\n@media only screen and (min-width: 1024px) {\n  .homePageText {\n    padding: 0.5em;\n    text-align: left;\n    padding-left: 13%;\n    font-size: 1.1em;\n    line-height: 1.6;\n    color: #333;\n  }\n}\n\n/* phone */\n@media screen and (max-width: 632px) {\n  .homePageText {\n    padding: 0.5em;\n    text-align: left;\n    padding-left: 5%;\n    font-size: 1.0em;\n    line-height: 1.5;\n    color: #444;\n  }\n\n  .video-responsive iframe {\n    width: 100%;\n    height: auto;\n    position: relative;\n  }\n}\n\n.video-responsive iframe {\n  padding-bottom: 3em;\n  border: none;\n  border-radius: 8px;\n}\n\n.title {\n  text-align: center;\n  font-size: 1.5em;\n  font-weight: 600;\n  color: #444;\n  margin: 1em 0;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Roboto', 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f7f8f9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 10vh;\n}\n\n* {\n  color: #222;\n  box-sizing: border-box;\n}\n\n.app {\n  height: 100%;\n  align-items: center;\n  text-align: center;\n  box-shadow: 0px 10px 10px 15px rgba(0, 0, 0, 0.05);\n  padding-top: 4px;\n  padding-bottom: 40px;\n  display: block;\n  background: white;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 1200px;\n}\n\n/* ANSWERS/RIGHT SECTION */\n.answer-section {\n  width: 100%;\n  flex-direction: column;\n  padding: 1em;\n  display: flex;\n  justify-content: center;\n}\n\n.correct {\n  background-color: #2f922f;\n  color: white;\n  font-weight: bold;\n  padding: 0.5em;\n  border-radius: 5px;\n}\n\n.incorrect {\n  background-color: #ff3333;\n  color: white;\n  font-weight: bold;\n  padding: 0.5em;\n  border-radius: 5px;\n}\n\nbutton {\n  background-color: #f3f3f3;\n  border: 0;\n  padding: 10px 20px;\n  cursor: pointer;\n  border-radius: 3px;\n  margin: 10px 0;\n  transition: background-color 0.3s ease;\n}\n\nbutton:hover {\n  background-color: #55555e;\n  color: white;\n}\n\nbutton svg {\n  margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
